import Breadcrumb from '@trilogy-ds/react/lib/components/breadcrumb/Breadcrumb';
export default Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map